import { z } from 'zod'

export const myAccountGetDownloadFileSchema = z.object({
  /** 繁中檔案名稱 */
  traditionalName: z.string(),
  /** 英文檔案名稱 */
  englishName: z.string(),
  /** 簡中檔案名稱 */
  simplifiedName: z.string(),
  /** 檔案Id */
  fileId: z.string()
})

export interface MyAccountGetDownloadFile
  extends z.infer<typeof myAccountGetDownloadFileSchema> {}

export class MyAccountGetDownloadFile {
  constructor() {
    return {
      traditionalName: '',
      englishName: '',
      simplifiedName: '',
      fileId: ''
    }
  }
}
